import {STEP_IDS} from "src/constants/mfr-constants";

export const PL_SLICE_OPTIONS = [
  { value: STEP_IDS.PNL_BY_SLICE_ASP_BAND, label: 'ASP Band' },
  { value: STEP_IDS.PNL_BY_SLICE_EVERYDAY_ESSENTIALS, label: 'Everyday Essentials' },
  { value: STEP_IDS.PNL_BY_SLICE_FC_TYPE, label: 'FC Type' },
  { value: STEP_IDS.PNL_BY_SLICE_PRIME_PLAN, label: 'Prime Plan' },
  { value: STEP_IDS.PNL_BY_SLICE_PRIVATE_BRANDS, label: 'Private Brands' },
  { value: STEP_IDS.PNL_BY_SLICE_SORT_TYPE, label: 'Sort Type' },
  { value: STEP_IDS.PNL_BY_SLICE_IS_SNS, label: 'SnS' },
  { value: STEP_IDS.PNL_BY_SLICE_BRAND_NAME, label: 'Brand Name' }
];

export const PL_DRILL_DOWN_OPTIONS = [
  { value: STEP_IDS.PNL_DRILL_DOWN_GMS, label: 'GMS' },
  { value: STEP_IDS.PNL_DRILL_DOWN_UNITS, label: 'Units' },
  { value: STEP_IDS.PNL_DRILL_DOWN_NET_REVENUE, label: 'Net Revenue' },
  { value: STEP_IDS.PNL_DRILL_DOWN_NET_PPM, label: 'Net PPM%' },
  { value: STEP_IDS.PNL_DRILL_DOWN_VENDOR_PROFIT, label: 'Vendor Profit' },
  { value: STEP_IDS.PNL_DRILL_DOWN_NET_SELLER_REIMBURSEMENTS, label: 'Net Seller Reimbursements' },
  { value: STEP_IDS.PNL_DRILL_DOWN_GROSS_PROFIT, label: 'Gross Profit' },
  { value: STEP_IDS.PNL_DRILL_DOWN_CONTRIBUTION_PROFIT, label: 'Contribution Profit' },
  { value: STEP_IDS.PNL_DRILL_DOWN_CP_LESS_OPS_FIELD_FIXED, label: 'CP Less Ops Field Fixed' },
  { value: STEP_IDS.PNL_DRILL_DOWN_OPERATING_INCOME, label: 'Operating Income' },
  { value: STEP_IDS.PNL_DRILL_DOWN_OPERATING_MARGIN_PCT, label: 'Operating Margin as % of Revenue' },
  { value: STEP_IDS.PNL_DRILL_DOWN_MARKETPLACE_REVENUE, label: 'Marketplace Rev' },
  { value: STEP_IDS.PNL_DRILL_DOWN_FREIGHT_IN_TOTAL, label: 'Freight In Total' },
  { value: STEP_IDS.PNL_DRILL_DOWN_SHIPPING_COGS, label: 'Shipping COGS' },
  { value: STEP_IDS.PNL_DRILL_DOWN_TOTAL_OPS_FIELD_FIXED, label: 'Total Ops Field Fixed Costs (incl Depreciation)' },
  { value: STEP_IDS.PNL_DRILL_DOWN_OPS_CS_VARIABLE_TOTAL, label: 'Ops & CS Variable Total' }
];
